import { formatDisplayDate, formatDisplayDateRange } from '../utils/displayDate';
export const PAYMENT_METHODS = [
  { id: 'wire', label: 'Wire / ACH', supportingText: 'Bank transfer instructions will be provided.' },
  { id: 'check', label: 'Check', supportingText: 'Mayker’s mailing address will be provided.' },
  { id: 'credit_card', label: 'Credit Card', supportingText: 'A 3% processing fee applies.' },
];

export const PAYMENT_METHOD_IDS = PAYMENT_METHODS.map((m) => m.id);
export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const NOT_YET_CONFIRMED = 'not_yet_confirmed';
export const COI_STATUS = {
  REQUIRED: 'required',
  NOT_REQUIRED: 'not_required',
  UNKNOWN: 'unknown',
};
export const COI_STATUS_LABELS = {
  required: 'Required',
  not_required: 'Not Required',
  unknown: 'Unknown / Client Unsure',
};

export const PRODUCTION_FIELDS = [
  { id: 'venueName', label: 'Venue', group: 'event' },
  { id: 'venueAddress', label: 'Venue Address', group: 'event' },
  { id: 'dayOfContact', label: 'Day-of Contact', group: 'event' },
  { id: 'dayOfContactPhone', label: 'Mobile Number', group: 'event' },
  { id: 'coiStatus', label: 'Certificate of Insurance', group: 'event' },
  { id: 'coiCertificateHolderName', label: 'Certificate Holder Name', group: 'event' },
  { id: 'coiCertificateHolderAddress', label: 'Certificate Holder Address', group: 'event' },
  { id: 'coiNotes', label: 'COI Notes', group: 'event' },
  { id: 'startDate', label: 'Delivery Date', group: 'delivery' },
  { id: 'deliveryTime', label: 'Delivery Time', group: 'delivery' },
  { id: 'hardSetTime', label: 'Hard Set Time', group: 'delivery' },
  { id: 'endDate', label: 'Strike Date', group: 'strike' },
  { id: 'strikeTime', label: 'Strike Time', group: 'strike' },
  { id: 'hardOutTime', label: 'Hard Out Time', group: 'strike' },
  { id: 'hardOutDate', label: 'Hard Out Date', group: 'strike', hidden: true },
];

export const AGREEMENT_SNAPSHOT_FIELDS = [
  { id: 'agreementCompanyName', label: 'Agreement Made Out To', group: 'agreement' },
  { id: 'agreementContactName', label: 'Agreement Contact', group: 'agreement' },
  { id: 'agreementEmail', label: 'Agreement Email', group: 'agreement' },
  { id: 'preferredPaymentMethod', label: 'Preferred Payment Method', group: 'agreement' },
];

const SCOPE_SENSITIVE_FIELD_IDS = {
  venueName: true,
  venueAddress: true,
  startDate: true,
  endDate: true,
  deliveryTime: true,
  strikeTime: true,
  hardSetTime: true,
  hardOutTime: true,
  hardOutDate: true,
};

const TIME_FIELD_IDS = {
  deliveryTime: true,
  strikeTime: true,
  hardSetTime: true,
  hardOutTime: true,
};

const DATE_FIELD_IDS = {
  startDate: true,
  endDate: true,
  hardOutDate: true,
};

const DEFAULT_EVENT_TIME_ZONE = 'America/Chicago';
const STATE_TIME_ZONES = {
  AL: 'America/Chicago', AK: 'America/Anchorage', AZ: 'America/Phoenix',
  AR: 'America/Chicago', CA: 'America/Los_Angeles', CO: 'America/Denver',
  CT: 'America/New_York', DC: 'America/New_York', DE: 'America/New_York',
  FL: 'America/New_York', GA: 'America/New_York', HI: 'Pacific/Honolulu',
  ID: 'America/Denver', IL: 'America/Chicago', IN: 'America/Indiana/Indianapolis',
  IA: 'America/Chicago', KS: 'America/Chicago', KY: 'America/New_York',
  LA: 'America/Chicago', ME: 'America/New_York', MD: 'America/New_York',
  MA: 'America/New_York', MI: 'America/Detroit', MN: 'America/Chicago',
  MS: 'America/Chicago', MO: 'America/Chicago', MT: 'America/Denver',
  NE: 'America/Chicago', NV: 'America/Los_Angeles', NH: 'America/New_York',
  NJ: 'America/New_York', NM: 'America/Denver', NY: 'America/New_York',
  NC: 'America/New_York', ND: 'America/Chicago', OH: 'America/New_York',
  OK: 'America/Chicago', OR: 'America/Los_Angeles', PA: 'America/New_York',
  RI: 'America/New_York', SC: 'America/New_York', SD: 'America/Chicago',
  TN: 'America/Chicago', TX: 'America/Chicago', UT: 'America/Denver',
  VT: 'America/New_York', VA: 'America/New_York', WA: 'America/Los_Angeles',
  WV: 'America/New_York', WI: 'America/Chicago', WY: 'America/Denver',
};
const STATE_NAME_TO_CODE = {
  alabama: 'AL', alaska: 'AK', arizona: 'AZ', arkansas: 'AR', california: 'CA',
  colorado: 'CO', connecticut: 'CT', delaware: 'DE', florida: 'FL', georgia: 'GA',
  hawaii: 'HI', idaho: 'ID', illinois: 'IL', indiana: 'IN', iowa: 'IA',
  kansas: 'KS', kentucky: 'KY', louisiana: 'LA', maine: 'ME', maryland: 'MD',
  massachusetts: 'MA', michigan: 'MI', minnesota: 'MN', mississippi: 'MS',
  missouri: 'MO', montana: 'MT', nebraska: 'NE', nevada: 'NV',
  'new hampshire': 'NH', 'new jersey': 'NJ', 'new mexico': 'NM', 'new york': 'NY',
  'north carolina': 'NC', 'north dakota': 'ND', ohio: 'OH', oklahoma: 'OK',
  oregon: 'OR', pennsylvania: 'PA', 'rhode island': 'RI', 'south carolina': 'SC',
  'south dakota': 'SD', tennessee: 'TN', texas: 'TX', utah: 'UT', vermont: 'VT',
  virginia: 'VA', washington: 'WA', 'west virginia': 'WV', wisconsin: 'WI',
  wyoming: 'WY', 'district of columbia': 'DC',
};
const GENERIC_ZONE_LABELS = [
  { match: ['America/New_York', 'America/Detroit', 'America/Kentucky/Louisville', 'America/Kentucky/Monticello', 'America/Indiana/Indianapolis', 'America/Indiana/Marengo', 'America/Indiana/Vevay', 'America/Indiana/Vincennes', 'America/Indiana/Winamac', 'America/Indiana/Petersburg'], name: 'Eastern Time', abbr: 'ET' },
  { match: ['America/Chicago', 'America/Menominee', 'America/Indiana/Tell_City', 'America/Indiana/Knox', 'America/North_Dakota/Center', 'America/North_Dakota/New_Salem', 'America/North_Dakota/Beulah'], name: 'Central Time', abbr: 'CT' },
  { match: ['America/Denver', 'America/Boise', 'America/Phoenix'], name: 'Mountain Time', abbr: 'MT' },
  { match: ['America/Los_Angeles'], name: 'Pacific Time', abbr: 'PT' },
  { match: ['America/Anchorage', 'America/Juneau', 'America/Sitka', 'America/Yakutat', 'America/Nome'], name: 'Alaska Time', abbr: 'AKT' },
  { match: ['Pacific/Honolulu', 'America/Adak'], name: 'Hawaii Time', abbr: 'HT' },
];
export const TIME_SLOT_OPTIONS = (() => {
  const slots = [];
  const hours = [12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
  ['AM', 'PM'].forEach((ap) => {
    hours.forEach((h) => {
      for (let m = 0; m < 60; m += 15) slots.push(`${h}:${String(m).padStart(2, '0')} ${ap}`);
    });
  });
  return slots;
})();

export const TIME_SUGGESTION_OPTIONS = (() => {
  const slots = [];
  const hours = [12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
  ['AM', 'PM'].forEach((ap) => {
    hours.forEach((h) => {
      slots.push(`${h}:00 ${ap}`);
      slots.push(`${h}:30 ${ap}`);
    });
  });
  return slots;
})();

const TERMINAL_PROJECT_STATUSES = new Set(['Confirmed', 'Completed', 'Cancelled', 'Closed']);

export function normalizeVersion(version) {
  if (version === undefined || version === null || version === '') return '1';
  return String(version).trim();
}

export function normalizeEmail(value) {
  return String(value || '').trim().toLowerCase();
}

export function isValidEmail(value) {
  return EMAIL_RE.test(String(value || '').trim());
}

export function paymentMethodLabel(id) {
  return PAYMENT_METHODS.find((m) => m.id === id)?.label || '';
}

export const STANDARD_DEPOSIT_CONFIRMATION_COPY =
  'A signed rental agreement and 50% deposit are required to confirm this project. Please confirm the agreement recipient and your preferred payment method below.';
export const STANDARD_FULL_PAYMENT_CONFIRMATION_COPY =
  'A signed rental agreement and full payment are required to confirm this project. Please confirm the agreement recipient and your preferred payment method below.';
export const STANDARD_PAYMENT_TERMS_LABEL = '50% deposit / balance per proposal terms';
// No determinable term: say nothing specific rather than inventing a 50% deposit.
export const UNSPECIFIED_PAYMENT_CONFIRMATION_COPY =
  'A signed rental agreement and payment per your proposal terms are required to confirm this project. Please confirm the agreement recipient and your preferred payment method below.';
const FULL_UPFRONT_PAYMENT_TERMS_LABEL = 'Full Payment Due Upfront';

export function parseStoredNetDays(value, { allowEmbedded } = {}) {
  const text = String(value || '').trim();
  if (!text) return null;
  const match = text.match(allowEmbedded ? /net[_\s-]*(\d+)/i : /^net[_\s-]*(\d+)$/i);
  if (!match) return null;
  const days = parseInt(match[1], 10);
  if (!Number.isInteger(days) || days < 1 || days > 365) return null;
  return days;
}

export function getProposalPaymentTerms(proposal) {
  const rec = proposal || {};
  const meta = readMetaFromNotes(rec.customProjectNotes) || {};
  return {
    id: String(rec.paymentTerms || meta.paymentTerms || '').trim(),
    notes: String(rec.paymentTermsNotes || meta.paymentTermsNotes || '').trim(),
  };
}

export function resolveConfirmationPaymentTerms(proposal) {
  const { id, notes } = getProposalPaymentTerms(proposal);
  const netDays = parseStoredNetDays(id) || (id === 'custom' ? parseStoredNetDays(notes, { allowEmbedded: true }) : null);
  if (netDays) {
    return { kind: 'net', id: id || `net_${netDays}`, days: netDays, label: `Net ${netDays}` };
  }
  if (id === 'full_upfront') {
    return { kind: 'full_upfront', id, days: null, label: FULL_UPFRONT_PAYMENT_TERMS_LABEL };
  }
  if (id === 'custom' && notes) {
    return { kind: 'custom', id, days: null, label: notes };
  }
  if (id === 'deposit_50') {
    return { kind: 'standard', id, days: null, label: STANDARD_PAYMENT_TERMS_LABEL };
  }
  // Blank, unknown, or Custom without a description. The dashboard sends the
  // effective Pending term, so a blank here is genuinely undetermined.
  return { kind: 'unspecified', id: '', days: null, label: '' };
}

export function confirmationPaymentTermsLabel(acceptance, proposal) {
  const stored = String((acceptance && acceptance.paymentTermsLabel) || '').trim();
  if (stored) return stored;
  if (acceptance && (acceptance.paymentTerms || acceptance.paymentTermsNotes || acceptance.customProjectNotes)) {
    return resolveConfirmationPaymentTerms(acceptance).label;
  }
  return resolveConfirmationPaymentTerms(proposal).label;
}

function netConfirmationCopy(days) {
  return `A signed rental agreement is required to confirm this project. Payment is due Net ${days} per the terms of your proposal. Please confirm the agreement recipient and your preferred payment method below.`;
}

export function stripClientNameVersion(name) {
  return String(name || '').replace(/\s*\(V\d+\)\s*$/, '').trim();
}

export function readMetaFromNotes(customProjectNotes) {
  const text = String(customProjectNotes || '');
  if (!text.trim()) return null;
  const markers = ['\n\n\u200B\u200BMAYKER_PAYMENT_V1:', '\n\nMAYKER_PAYMENT_V1:', 'MAYKER_PAYMENT_V1:'];
  for (let i = 0; i < markers.length; i += 1) {
    const marker = markers[i];
    const idx = text.lastIndexOf(marker);
    if (idx === -1) continue;
    try {
      const meta = JSON.parse(text.slice(idx + marker.length).trim());
      if (meta && typeof meta === 'object' && !Array.isArray(meta)) return meta;
    } catch (_) { /* keep looking */ }
  }
  return null;
}

export function getAcceptanceFromProposal(proposal) {
  if (!proposal) return null;
  if (proposal.proposalAcceptance && typeof proposal.proposalAcceptance === 'object') {
    return proposal.proposalAcceptance;
  }
  const meta = readMetaFromNotes(proposal.customProjectNotes);
  const raw = meta && meta.proposalAcceptance;
  return raw && typeof raw === 'object' ? raw : null;
}

const CONFIRMATION_REPLAY_PROJECTS = {
  693: true,
};

export function isConfirmationReplayProject(projectNumber) {
  const digits = String(projectNumber || '').replace(/\D/g, '');
  if (!digits) return false;
  return Boolean(CONFIRMATION_REPLAY_PROJECTS[String(parseInt(digits, 10))]);
}

export const ACCEPTANCE_SUBMIT_TIMEOUT_MS = 25000;
export const ACCEPTANCE_SUBMIT_TIMEOUT_MESSAGE =
  'This is taking longer than expected. Refresh the proposal in a minute before submitting again — your confirmation may still be saving.';

export function kickConfirmationHandoff({
  adminApiUrl,
  appsScriptUrl,
  projectNumber,
  version,
  skipDocumentGeneration = false,
}) {
  const body = {
    type: 'runConfirmationHandoff',
    projectNumber: String(projectNumber || '').trim(),
    version: version == null || version === '' ? 1 : version,
    skipDocumentGeneration: skipDocumentGeneration === true,
  };
  if (!body.projectNumber) return;
  if (adminApiUrl) {
    void fetch(adminApiUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
      keepalive: true,
    }).catch(() => {});
    return;
  }
  if (appsScriptUrl) {
    void fetch(appsScriptUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain' },
      body: JSON.stringify(body),
      mode: 'cors',
      keepalive: true,
    }).catch(() => {});
  }
}

export function slimProposalSnapshot(proposal) {
  const rec = proposal || {};
  return {
    projectNumber: rec.projectNumber || '',
    version: rec.version,
    status: rec.status || '',
    clientName: rec.clientName || '',
    venueName: rec.venueName || '',
    venueAddress: rec.venueAddress || '',
    startDate: rec.startDate || '',
    endDate: rec.endDate || '',
    salesLead: rec.salesLead || '',
    clientFolderURL: rec.clientFolderURL || '',
    rwTicket: rec.rwTicketNumber || rec.rwTicket || '',
    rwTicketNumber: rec.rwTicketNumber || rec.rwTicket || '',
    customProjectNotes: rec.customProjectNotes || '',
    proposalAcceptance: rec.proposalAcceptance || null,
    eventTimeZone: rec.eventTimeZone || rec.timezone || '',
    paymentTerms: rec.paymentTerms || '',
    paymentTermsNotes: rec.paymentTermsNotes || '',
  };
}

async function fetchJsonWithTimeout(url, options, timeoutMs) {
  const limit = timeoutMs || ACCEPTANCE_SUBMIT_TIMEOUT_MS;
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), limit);
  try {
    const response = await fetch(url, { ...(options || {}), signal: controller.signal });
    const result = await response.json().catch(() => ({}));
    return { response, result };
  } catch (err) {
    if (err && (err.name === 'AbortError' || err.name === 'TimeoutError')) {
      throw new Error(ACCEPTANCE_SUBMIT_TIMEOUT_MESSAGE);
    }
    throw err;
  } finally {
    clearTimeout(timer);
  }
}

export function getAcceptanceUiState(proposal) {
  const acceptance = getAcceptanceFromProposal(proposal);
  if (!acceptance || !acceptance.acceptedAt) return 'none';
  const acceptedVersion = normalizeVersion(acceptance.acceptedProposalVersion);
  const currentVersion = normalizeVersion(proposal && proposal.version);
  if (acceptedVersion && currentVersion && acceptedVersion !== currentVersion) {
    return 'needs_reacceptance';
  }
  return 'accepted';
}

export function isOpenReapprovalRequest(acceptance, version) {
  const request = acceptance && acceptance.reapprovalRequest;
  if (!request || String(request.status || '').trim() !== 'open') return false;
  const requested = parseInt(request.requestedVersion, 10);
  const current = parseInt(version, 10);
  return Number.isFinite(requested) && Number.isFinite(current) && requested === current && requested >= 1;
}

export function phoneDigits(value) {
  return String(value || '').replace(/\D/g, '');
}

export function formatPhoneInput(value) {
  const raw = String(value || '');
  const trimmed = raw.trim();
  if (trimmed.startsWith('+')) {
    return `+${trimmed.slice(1).replace(/[^\d\s()-]/g, '')}`.replace(/\s{2,}/g, ' ').trimEnd();
  }
  const digits = phoneDigits(raw);
  if (digits.length > 11 || (digits.length === 11 && digits[0] !== '1')) {
    return raw.replace(/[^\d\s()-]/g, '');
  }
  const d = digits.length === 11 && digits[0] === '1' ? digits.slice(1) : digits;
  if (!d) return '';
  if (d.length <= 2) return d;
  if (d.length === 3) return `(${d})`;
  if (d.length <= 6) return `(${d.slice(0, 3)}) ${d.slice(3)}`;
  return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6, 10)}`;
}

export function normalizeCoiStatus(value) {
  const raw = String(value || '').trim().toLowerCase();
  if (!raw) return '';
  if (raw === COI_STATUS.REQUIRED || raw === 'yes' || raw === 'needed' || raw === 'required') return COI_STATUS.REQUIRED;
  if (raw === COI_STATUS.NOT_REQUIRED || raw === 'not required' || raw === 'no' || raw === 'false') return COI_STATUS.NOT_REQUIRED;
  if (raw === COI_STATUS.UNKNOWN || raw === 'unsure' || raw === 'not sure' || raw === 'unknown / client unsure' || raw === 'client unsure') return COI_STATUS.UNKNOWN;
  return '';
}

export function coiStatusLabel(value) {
  const status = normalizeCoiStatus(value);
  return status ? COI_STATUS_LABELS[status] : '';
}

export function resolveCoiStatus(existing, incoming) {
  const next = normalizeCoiStatus(incoming);
  if (next) return next;
  return normalizeCoiStatus(existing);
}

export function existingCoiFromProposal(proposal) {
  const acceptance = getAcceptanceFromProposal(proposal);
  const details = (acceptance && acceptance.productionDetails) || {};
  const rec = proposal || {};
  return {
    coiStatus: resolveCoiStatus('', firstNonEmpty(rec.coiStatus, rec.certificateOfInsurance, rec.coi, details.coiStatus)),
    coiCertificateHolderName: String(details.coiCertificateHolderName || rec.coiCertificateHolderName || '').trim(),
    coiCertificateHolderAddress: String(details.coiCertificateHolderAddress || rec.coiCertificateHolderAddress || '').trim(),
    coiNotes: String(details.coiNotes || rec.coiNotes || '').trim(),
  };
}

export function applyResolvedCoiDetails(details, proposal) {
  const existing = existingCoiFromProposal(proposal);
  const next = Object.assign({}, details || {});
  next.coiStatus = resolveCoiStatus(existing.coiStatus, next.coiStatus);
  if (next.coiStatus === COI_STATUS.REQUIRED) {
    next.coiCertificateHolderName = String(next.coiCertificateHolderName || existing.coiCertificateHolderName || '').trim();
    next.coiCertificateHolderAddress = String(next.coiCertificateHolderAddress || existing.coiCertificateHolderAddress || '').trim();
    next.coiNotes = String(next.coiNotes || existing.coiNotes || '').trim();
  } else {
    next.coiCertificateHolderName = '';
    next.coiCertificateHolderAddress = '';
    next.coiNotes = '';
  }
  return next;
}

export function isCoiRequired(value) {
  return normalizeCoiStatus(value) === COI_STATUS.REQUIRED;
}

export function buildProductionSnapshot(proposal, clientProfile) {
  const snapshot = {};
  PRODUCTION_FIELDS.forEach((field) => {
    const raw = proposal ? proposal[field.id] : '';
    snapshot[field.id] = raw == null ? '' : String(raw).trim();
  });
  const dayOf = prefillDayOfContactFields(proposal, clientProfile);
  if (!snapshot.dayOfContact) snapshot.dayOfContact = dayOf.dayOfContact;
  snapshot.dayOfContactPhone = formatPhoneInput(snapshot.dayOfContactPhone || dayOf.dayOfContactPhone);
  if (!normalizeClock12(snapshot.hardSetTime)) snapshot.hardSetTime = defaultHardSetTime(snapshot.deliveryTime);
  if (!normalizeClock12(snapshot.hardOutTime)) snapshot.hardOutTime = defaultHardOutTime(snapshot.strikeTime);
  const existingCoi = existingCoiFromProposal(proposal);
  if (!normalizeCoiStatus(snapshot.coiStatus)) snapshot.coiStatus = existingCoi.coiStatus;
  if (!String(snapshot.coiCertificateHolderName || '').trim()) snapshot.coiCertificateHolderName = existingCoi.coiCertificateHolderName;
  if (!String(snapshot.coiCertificateHolderAddress || '').trim()) snapshot.coiCertificateHolderAddress = existingCoi.coiCertificateHolderAddress;
  if (!String(snapshot.coiNotes || '').trim()) snapshot.coiNotes = existingCoi.coiNotes;
  return snapshot;
}

export function parseYmd(value) {
  const match = String(value || '').trim().match(/^(\d{4}-\d{2}-\d{2})/);
  if (match) return match[1];
  const us = String(value || '').trim().match(/^(\d{1,2})[/-](\d{1,2})[/-](\d{4})$/);
  if (us) return `${us[3]}-${String(us[1]).padStart(2, '0')}-${String(us[2]).padStart(2, '0')}`;
  return '';
}

export function formatUsDate(value) {
  return formatDisplayDate(parseYmd(value));
}

export function addDaysToYmd(ymd, dayCount) {
  const base = parseYmd(ymd);
  if (!base) return '';
  const [y, m, d] = base.split('-').map((n) => parseInt(n, 10));
  const dt = new Date(y, m - 1, d + dayCount);
  if (isNaN(dt.getTime())) return '';
  return `${dt.getFullYear()}-${String(dt.getMonth() + 1).padStart(2, '0')}-${String(dt.getDate()).padStart(2, '0')}`;
}

function pad2(value) {
  return String(value).padStart(2, '0');
}

function parsePeriodToken(token) {
  const t = String(token || '').replace(/\./g, '').trim().toLowerCase();
  if (t === 'a' || t === 'am') return 'AM';
  if (t === 'p' || t === 'pm') return 'PM';
  return '';
}

export function formatClock12FromParts(parts) {
  if (!parts) return '';
  const hour = Math.min(12, Math.max(1, Number(parts.hour) || 12));
  const minute = Math.min(59, Math.max(0, Number(parts.minute) || 0));
  const period = String(parts.period || 'PM').toUpperCase() === 'AM' ? 'AM' : 'PM';
  return `${hour}:${pad2(minute)} ${period}`;
}

export function parseClockParts(value) {
  const clock = normalizeClock12(value);
  const match = clock.match(/^(\d{1,2}):(\d{2})\s(AM|PM)$/);
  if (!match) return null;
  return { hour: parseInt(match[1], 10), minute: parseInt(match[2], 10), period: match[3] };
}

export function normalizeClock12(value) {
  const raw = String(value || '')
    .trim()
    .replace(/\s+(CST|CDT|EST|EDT|MST|MDT|PST|PDT|CT|ET|MT|PT)\s*$/i, '')
    .replace(/\s+/g, ' ')
    .trim();
  if (!raw) return '';

  const withPeriod = raw.match(/^(\d{1,2}):(\d{2})(?::\d{2})?\s*([AaPp](?:\.?[Mm]\.?)?)\s*$/);
  if (withPeriod) {
    const minute = parseInt(withPeriod[2], 10);
    if (minute > 59) return '';
    return formatClock12FromParts({
      hour: parseInt(withPeriod[1], 10),
      minute,
      period: parsePeriodToken(withPeriod[3]),
    });
  }

  const hourPeriod = raw.match(/^(\d{1,2})\s*([AaPp](?:\.?[Mm]\.?)?)\s*$/);
  if (hourPeriod) {
    const hour = parseInt(hourPeriod[1], 10);
    if (hour < 1 || hour > 12) return '';
    return formatClock12FromParts({
      hour,
      minute: 0,
      period: parsePeriodToken(hourPeriod[2]),
    });
  }

  const compactPeriod = raw.match(/^(\d{1,2})([0-5]\d)\s*([AaPp](?:\.?[Mm]\.?)?)\s*$/);
  if (compactPeriod) {
    const hour = parseInt(compactPeriod[1], 10);
    if (hour < 1 || hour > 12) return '';
    return formatClock12FromParts({
      hour,
      minute: parseInt(compactPeriod[2], 10),
      period: parsePeriodToken(compactPeriod[3]),
    });
  }

  const m24 = raw.match(/^(\d{1,2}):(\d{2})(?::\d{2})?$/);
  if (m24) {
    const hours = parseInt(m24[1], 10);
    const minute = parseInt(m24[2], 10);
    if (hours > 23 || minute > 59) return '';
    return formatClock12FromParts({
      hour: hours % 12 || 12,
      minute,
      period: hours >= 12 ? 'PM' : 'AM',
    });
  }

  const bare = raw.match(/^(\d{1,2})$/);
  if (bare) {
    const hour = parseInt(bare[1], 10);
    if (hour === 0) return formatClock12FromParts({ hour: 12, minute: 0, period: 'AM' });
    if (hour >= 1 && hour <= 12) return formatClock12FromParts({ hour, minute: 0, period: 'PM' });
    if (hour <= 23) return formatClock12FromParts({ hour: hour % 12 || 12, minute: 0, period: 'PM' });
  }

  return '';
}

function hasExplicitPeriod(raw) {
  return /[AaPp]/.test(String(raw || ''));
}

function inferPeriodFromPrevious(previous) {
  const prev = parseClockParts(previous);
  return prev ? prev.period : '';
}

export function normalizeTypedClock12(value, previous) {
  const raw = String(value || '')
    .trim()
    .replace(/\s+(CST|CDT|EST|EDT|MST|MDT|PST|PDT|CT|ET|MT|PT)\s*$/i, '')
    .replace(/\s+/g, ' ')
    .trim();
  if (!raw) return '';

  if (hasExplicitPeriod(raw)) return normalizeClock12(raw);

  const m24 = raw.match(/^(\d{1,2}):(\d{2})(?::\d{2})?$/);
  if (m24) {
    const hours = parseInt(m24[1], 10);
    const minute = parseInt(m24[2], 10);
    if (hours > 23 || minute > 59) return '';
    if (hours === 0 || hours >= 13) {
      return formatClock12FromParts({
        hour: hours % 12 || 12,
        minute,
        period: hours >= 12 ? 'PM' : 'AM',
      });
    }
    const period = inferPeriodFromPrevious(previous);
    if (!period) return '';
    return formatClock12FromParts({
      hour: hours === 0 ? 12 : hours,
      minute,
      period,
    });
  }

  const compact = raw.match(/^(\d{1,2})([0-5]\d)$/);
  if (compact) {
    const hour = parseInt(compact[1], 10);
    const minute = parseInt(compact[2], 10);
    if (hour > 23) return '';
    if (hour === 0 || hour >= 13) {
      return formatClock12FromParts({
        hour: hour % 12 || 12,
        minute,
        period: hour >= 12 ? 'PM' : 'AM',
      });
    }
    const period = inferPeriodFromPrevious(previous);
    if (!period) return '';
    return formatClock12FromParts({ hour, minute, period });
  }

  const bare = raw.match(/^(\d{1,2})$/);
  if (bare) {
    const hour = parseInt(bare[1], 10);
    if (hour === 0) return formatClock12FromParts({ hour: 12, minute: 0, period: 'AM' });
    if (hour >= 13 && hour <= 23) {
      return formatClock12FromParts({ hour: hour % 12 || 12, minute: 0, period: 'PM' });
    }
    if (hour >= 1 && hour <= 12) {
      const period = inferPeriodFromPrevious(previous);
      if (!period) return '';
      return formatClock12FromParts({ hour, minute: 0, period });
    }
  }

  return '';
}

export function clockInputErrorMessage(value, previous) {
  const raw = String(value || '').trim();
  if (!raw) return '';
  if (normalizeTypedClock12(raw, previous)) return '';
  const compact = raw.replace(/\s+/g, '');
  const clockLike = compact.match(/^(\d{1,2})(?::(\d{2}))$/) || compact.match(/^(\d{1,2})([0-5]\d)$/) || compact.match(/^(\d{1,2})$/);
  if (clockLike) {
    const hour = parseInt(clockLike[1], 10);
    if (hour >= 1 && hour <= 12) return 'Add AM or PM';
  }
  return 'Enter a valid time, like 11:00 PM';
}

export function filterTimeSuggestions(draft, extraValue) {
  const extra = normalizeClock12(extraValue);
  const options = TIME_SUGGESTION_OPTIONS.slice();
  if (extra && options.indexOf(extra) === -1) options.unshift(extra);

  const raw = String(draft || '').trim().toLowerCase();
  if (!raw) return options;

  const compact = raw.replace(/[\s.]/g, '');
  const hourMatch = compact.match(/^(\d{1,2})/);
  const hour = hourMatch ? parseInt(hourMatch[1], 10) : NaN;
  const wantsPm = /p/.test(compact);
  const wantsAm = /a/.test(compact) && !wantsPm;

  const filtered = options.filter((opt) => {
    const parts = parseClockParts(opt);
    if (!parts) return false;
    if (wantsPm && parts.period !== 'PM') return false;
    if (wantsAm && parts.period !== 'AM') return false;
    if (isNaN(hour)) return opt.toLowerCase().indexOf(raw) !== -1;
    if (hour === 0) return parts.hour === 12 && parts.period === 'AM';
    if (hour >= 13 && hour <= 23) {
      return parts.hour === (hour % 12 || 12) && parts.period === 'PM';
    }
    return parts.hour === hour;
  });

  return filtered.length ? filtered : options;
}

function clock12ToMinutes(value) {
  const clock = normalizeClock12(value);
  const match = clock.match(/^(\d{1,2}):(\d{2})\s(AM|PM)$/i);
  if (!match) return null;
  let hours = parseInt(match[1], 10);
  const minutes = parseInt(match[2], 10);
  const ap = match[3].toUpperCase();
  if (ap === 'AM') hours = hours === 12 ? 0 : hours;
  else hours = hours === 12 ? 12 : hours + 12;
  return hours * 60 + minutes;
}

const HARD_SET_HOURS_AFTER_DELIVERY = 4;
const HARD_OUT_HOURS_AFTER_STRIKE = 3;

export function addHoursToClock12(value, hours) {
  const mins = clock12ToMinutes(value);
  if (mins == null || hours == null || isNaN(Number(hours))) return '';
  const day = 24 * 60;
  let next = mins + Math.round(Number(hours) * 60);
  next = ((next % day) + day) % day;
  const hour24 = Math.floor(next / 60);
  return formatClock12FromParts({
    hour: hour24 % 12 || 12,
    minute: next % 60,
    period: hour24 >= 12 ? 'PM' : 'AM',
  });
}

export function defaultHardSetTime(deliveryTime) {
  return addHoursToClock12(deliveryTime, HARD_SET_HOURS_AFTER_DELIVERY);
}

export function defaultHardOutTime(strikeTime) {
  return addHoursToClock12(strikeTime, HARD_OUT_HOURS_AFTER_STRIKE);
}

export function applyLinkedHardScheduleTimes(prev, next, changedId) {
  const out = Object.assign({}, next);
  if (changedId === 'deliveryTime') {
    const prevDefault = defaultHardSetTime(prev && prev.deliveryTime);
    if (!normalizeClock12(prev && prev.hardSetTime) || normalizeClock12(prev.hardSetTime) === prevDefault) {
      out.hardSetTime = defaultHardSetTime(out.deliveryTime);
    }
  }
  if (changedId === 'strikeTime') {
    const prevDefault = defaultHardOutTime(prev && prev.strikeTime);
    if (!normalizeClock12(prev && prev.hardOutTime) || normalizeClock12(prev.hardOutTime) === prevDefault) {
      out.hardOutTime = defaultHardOutTime(out.strikeTime);
    }
  }
  return out;
}

export function timeSelectOptions(currentValue) {
  const normalized = normalizeClock12(currentValue);
  if (normalized && TIME_SLOT_OPTIONS.indexOf(normalized) === -1) return [normalized].concat(TIME_SLOT_OPTIONS);
  return TIME_SLOT_OPTIONS;
}

export function inferRolloverDate(anchorDate, startTime, laterTime) {
  const date = parseYmd(anchorDate);
  if (!date || !laterTime) return '';
  const startMin = clock12ToMinutes(startTime);
  const laterMin = clock12ToMinutes(laterTime);
  if (laterMin == null) return date;
  if (startMin != null && laterMin < startMin) return addDaysToYmd(date, 1);
  return date;
}

export function formatContextDate(ymd) {
  const date = parseYmd(ymd);
  if (!date) return '';
  const [y, m, d] = date.split('-').map((n) => parseInt(n, 10));
  const dt = new Date(y, m - 1, d);
  if (isNaN(dt.getTime())) return '';
  return dt.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' });
}

export function parseStateFromAddress(address) {
  const text = String(address || '').trim();
  if (!text) return '';
  const zip = text.match(/\b([A-Za-z]{2})\s+\d{5}(?:-\d{4})?\b/);
  if (zip && STATE_TIME_ZONES[zip[1].toUpperCase()]) return zip[1].toUpperCase();
  const comma = text.match(/,\s*([A-Za-z]{2})\b/);
  if (comma && STATE_TIME_ZONES[comma[1].toUpperCase()]) return comma[1].toUpperCase();
  const lower = text.toLowerCase();
  const names = Object.keys(STATE_NAME_TO_CODE).sort((a, b) => b.length - a.length);
  for (let i = 0; i < names.length; i += 1) {
    if (lower.indexOf(names[i]) !== -1) return STATE_NAME_TO_CODE[names[i]];
  }
  return '';
}

export function resolveVenueTimeZone({ proposal, venueAddress } = {}) {
  const rec = proposal || {};
  const nextAddress = String(venueAddress != null ? venueAddress : rec.venueAddress || '').trim();
  const originalAddress = String(rec.venueAddress || '').trim();
  const addressChanged = nextAddress.toLowerCase() !== originalAddress.toLowerCase();
  const stateFromAddress = parseStateFromAddress(nextAddress);
  if (addressChanged && stateFromAddress) return STATE_TIME_ZONES[stateFromAddress] || DEFAULT_EVENT_TIME_ZONE;
  const existing = String(rec.eventTimeZone || rec.timezone || '').trim();
  if (existing) return existing;
  return STATE_TIME_ZONES[stateFromAddress || rec.state] || DEFAULT_EVENT_TIME_ZONE;
}

export function formatDateAwareTimeZone(iana, dateKey) {
  const zone = String(iana || DEFAULT_EVENT_TIME_ZONE).trim() || DEFAULT_EVENT_TIME_ZONE;
  const ymd = parseYmd(dateKey);
  const date = ymd ? new Date(`${ymd}T12:00:00`) : new Date();
  try {
    const longParts = new Intl.DateTimeFormat('en-US', { timeZone: zone, timeZoneName: 'long' }).formatToParts(date);
    const shortParts = new Intl.DateTimeFormat('en-US', { timeZone: zone, timeZoneName: 'short' }).formatToParts(date);
    const longName = ((longParts.find((part) => part.type === 'timeZoneName') || {}).value || '').trim();
    const abbr = ((shortParts.find((part) => part.type === 'timeZoneName') || {}).value || '').trim();
    if (longName && abbr && !/^GMT/i.test(abbr) && !/^UTC/i.test(abbr)) {
      return { longName, abbr, iana: zone };
    }
  } catch (_) { /* fall through */ }
  for (let i = 0; i < GENERIC_ZONE_LABELS.length; i += 1) {
    if (GENERIC_ZONE_LABELS[i].match.indexOf(zone) !== -1) {
      return { longName: GENERIC_ZONE_LABELS[i].name, abbr: GENERIC_ZONE_LABELS[i].abbr, iana: zone };
    }
  }
  return { longName: 'Central Standard Time', abbr: 'CST', iana: DEFAULT_EVENT_TIME_ZONE };
}

export function formatClientTimeZoneLine(iana, dateKey) {
  const zone = formatDateAwareTimeZone(iana, dateKey);
  return `All times shown in ${zone.longName} (${zone.abbr}).`;
}

export function formatScheduleTimeZoneLabel(iana, dateKey) {
  const zone = formatDateAwareTimeZone(iana, dateKey);
  return zone.longName ? `All times in ${zone.longName}` : '';
}

export function formatTimeZoneAbbr(iana, dateKey) {
  return formatDateAwareTimeZone(iana, dateKey).abbr || '';
}

export function applyInferredScheduleDates(details) {
  const next = Object.assign({}, details || {});
  next.hardOutDate = inferRolloverDate(next.endDate, next.strikeTime, next.hardOutTime);
  return next;
}

function normalizeProductionValue(value) {
  if (value === NOT_YET_CONFIRMED) return NOT_YET_CONFIRMED;
  return value == null ? '' : String(value).trim();
}

function collapseWhitespace(value) {
  return String(value || '').replace(/\s+/g, ' ').trim();
}

export function confirmationValuesEquivalent(fieldId, previous, next) {
  if (previous === NOT_YET_CONFIRMED || next === NOT_YET_CONFIRMED) return previous === next;
  if (fieldId === 'dayOfContactPhone') {
    const prevDigits = phoneDigits(previous);
    const nextDigits = phoneDigits(next);
    if (prevDigits || nextDigits) return prevDigits === nextDigits;
    return collapseWhitespace(previous) === collapseWhitespace(next);
  }
  if (fieldId === 'agreementEmail') return normalizeEmail(previous) === normalizeEmail(next);
  if (TIME_FIELD_IDS[fieldId]) {
    const prevClock = normalizeClock12(previous);
    const nextClock = normalizeClock12(next);
    if (prevClock || nextClock) return prevClock === nextClock;
    return collapseWhitespace(previous) === collapseWhitespace(next);
  }
  if (DATE_FIELD_IDS[fieldId]) {
    const prevDate = parseYmd(previous);
    const nextDate = parseYmd(next);
    if (prevDate || nextDate) return prevDate === nextDate;
    return collapseWhitespace(previous) === collapseWhitespace(next);
  }
  return collapseWhitespace(previous).toLowerCase() === collapseWhitespace(next).toLowerCase();
}

function formatConfirmationDate(value) {
  const ymd = parseYmd(value);
  if (!ymd) return collapseWhitespace(value);
  return formatDisplayDate(ymd);
}

function formatConfirmationFieldValue(fieldId, value) {
  if (value === NOT_YET_CONFIRMED) return 'Not yet confirmed';
  const raw = value == null ? '' : String(value).trim();
  if (!raw) return '';
  if (fieldId === 'preferredPaymentMethod') return paymentMethodLabel(raw) || raw;
  if (fieldId === 'coiStatus') return coiStatusLabel(raw) || raw;
  if (fieldId === 'agreementEmail') return normalizeEmail(raw);
  if (fieldId === 'dayOfContactPhone') return formatPhoneInput(raw) || raw;
  if (TIME_FIELD_IDS[fieldId]) return normalizeClock12(raw) || raw;
  if (DATE_FIELD_IDS[fieldId]) return formatConfirmationDate(raw);
  return collapseWhitespace(raw);
}

function snapshotFieldRecord(field, previous, submitted, options) {
  const skipEmptyChange = options && options.skipEmptyPrevious;
  let changed = !confirmationValuesEquivalent(field.id, previous, submitted);
  if (skipEmptyChange && !collapseWhitespace(previous) && collapseWhitespace(submitted)) changed = false;
  return {
    id: field.id,
    label: field.label,
    group: field.group || '',
    previous: formatConfirmationFieldValue(field.id, previous),
    submitted: formatConfirmationFieldValue(field.id, submitted),
    changed,
    scopeSensitive: Boolean(SCOPE_SENSITIVE_FIELD_IDS[field.id]),
  };
}

export function buildConfirmationSnapshot({
  proposal, fields, productionDetails, originalProduction, originalAgreement, productionNotes, supportingDocuments, eventTimeZone, submittedAt,
}) {
  const inferred = applyInferredScheduleDates(productionDetails);
  const productionBaseline = applyInferredScheduleDates(originalProduction || buildProductionSnapshot(proposal));
  const agreementBaseline = originalAgreement || prefillAgreementFields(proposal);
  const fieldRecords = [];
  AGREEMENT_SNAPSHOT_FIELDS.forEach((field) => {
    fieldRecords.push(snapshotFieldRecord(field, agreementBaseline[field.id], fields && fields[field.id], {
      skipEmptyPrevious: field.id === 'preferredPaymentMethod',
    }));
  });
  PRODUCTION_FIELDS.forEach((field) => {
    fieldRecords.push(snapshotFieldRecord(field, productionBaseline[field.id], inferred && inferred[field.id]));
  });
  const notes = String(productionNotes || '').trim();
  fieldRecords.push(snapshotFieldRecord({ id: 'productionNotes', label: 'Additional Notes', group: 'notes' }, '', notes));
  const originalZone = String((proposal && (proposal.eventTimeZone || proposal.timezone)) || '').trim();
  const zone = String(eventTimeZone || '').trim();
  if (zone || originalZone) {
    fieldRecords.push(snapshotFieldRecord({ id: 'eventTimeZone', label: 'Time Zone', group: 'event' }, originalZone, zone, { skipEmptyPrevious: true }));
  }
  const documents = normalizeSupportingDocuments(supportingDocuments);
  const changedFields = fieldRecords.filter((field) => field.changed);
  return {
    submittedAt: submittedAt || new Date().toISOString(),
    fields: fieldRecords,
    documents,
    changes: changedFields,
    newDocuments: documents,
    noChanges: changedFields.length === 0 && documents.length === 0,
    hasScopeSensitiveChanges: changedFields.some((field) => field.scopeSensitive),
  };
}

export function collectProductionChanges(originalSnapshot, nextDetails, notYetConfirmed, extras) {
  const changes = [];
  const unconfirmed = Array.isArray(notYetConfirmed) ? notYetConfirmed : [];
  PRODUCTION_FIELDS.forEach((field) => {
    const original = normalizeProductionValue(originalSnapshot && originalSnapshot[field.id]);
    const next = unconfirmed.includes(field.id)
      ? NOT_YET_CONFIRMED
      : normalizeProductionValue(nextDetails && nextDetails[field.id]);
    if (!confirmationValuesEquivalent(field.id, original, next)) {
      changes.push({
        field: field.id,
        label: field.label,
        original: formatConfirmationFieldValue(field.id, original),
        updated: formatConfirmationFieldValue(field.id, next),
        scopeSensitive: Boolean(SCOPE_SENSITIVE_FIELD_IDS[field.id]),
      });
    }
  });
  const notes = String(extras && extras.productionNotes || '').trim();
  if (notes) {
    changes.push({ field: 'productionNotes', label: 'Additional Notes', original: '', updated: notes, scopeSensitive: false });
  }
  const originalZone = String(extras && extras.originalTimeZone || '').trim();
  const nextZone = String(extras && extras.eventTimeZone || '').trim();
  if (nextZone && originalZone && nextZone !== originalZone) {
    changes.push({ field: 'eventTimeZone', label: 'Time Zone', original: originalZone, updated: nextZone, scopeSensitive: false });
  }
  return changes;
}

function firstNonEmpty() {
  for (let i = 0; i < arguments.length; i += 1) {
    const value = String(arguments[i] || '').trim();
    if (value) return value;
  }
  return '';
}

function nameFromParts(source) {
  if (!source || typeof source !== 'object') return '';
  return [source.firstName, source.lastName].filter(Boolean).join(' ').trim();
}

function asRecord(value) {
  return value && typeof value === 'object' && !Array.isArray(value) ? value : {};
}

function copperContactRecord(proposal) {
  const rec = proposal || {};
  return asRecord(rec.copperContact || rec.opportunityContact || rec.primaryContact);
}

export function prefillAgreementFields(proposal, clientProfile) {
  const profile = clientProfile || {};
  const rec = proposal || {};
  const nestedClient = asRecord(rec.client);
  const copper = copperContactRecord(rec);
  const company = firstNonEmpty(
    profile.companyName,
    profile.clientCompanyName,
    profile.client_name,
    rec.agreementCompanyName,
    nestedClient.companyName,
    nestedClient.clientCompanyName,
    stripClientNameVersion(rec.clientName)
  );
  const contact = firstNonEmpty(
    rec.copperContactName,
    rec.opportunityContactName,
    rec.primaryContactName,
    copper.fullName,
    copper.contactName,
    copper.name,
    nameFromParts(copper),
    rec.contactName
  );
  const email = firstNonEmpty(
    rec.copperContactEmail,
    rec.opportunityContactEmail,
    rec.primaryContactEmail,
    copper.email,
    copper.contactEmail,
    rec.contactEmail
  );
  return { agreementCompanyName: company, agreementContactName: contact, agreementEmail: email };
}

export function emptyAcceptanceContactPrefill() {
  return {
    copperContactName: '',
    copperContactEmail: '',
    contactName: '',
    contactEmail: '',
    eventContactName: '',
    eventContactPhone: '',
  };
}

export function applyAcceptanceContactPrefill(proposal, contacts) {
  const src = contacts || {};
  const name = firstNonEmpty(
    src.copperContactName,
    src.opportunityContactName,
    src.primaryContactName,
    src.contactName
  );
  const email = firstNonEmpty(
    src.copperContactEmail,
    src.opportunityContactEmail,
    src.primaryContactEmail,
    src.contactEmail
  );
  const eventName = firstNonEmpty(src.eventContactName, src.dayOfContact);
  const eventPhone = firstNonEmpty(src.eventContactPhone, src.dayOfContactPhone);
  return {
    ...(proposal || {}),
    copperContactName: name,
    copperContactEmail: email,
    contactName: name,
    contactEmail: email,
    eventContactName: eventName,
    eventContactPhone: eventPhone,
    dayOfContact: eventName,
    dayOfContactPhone: eventPhone,
  };
}

export function isAcceptanceContactPrefillPayload(data) {
  if (!data || typeof data !== 'object' || Array.isArray(data.proposals)) return false;
  return (
    Object.prototype.hasOwnProperty.call(data, 'contactName') ||
    Object.prototype.hasOwnProperty.call(data, 'copperContactName') ||
    Object.prototype.hasOwnProperty.call(data, 'eventContactName')
  );
}

export function liveContactFormValues(contacts) {
  const src = contacts || {};
  return {
    agreementContactName: firstNonEmpty(src.copperContactName, src.contactName),
    agreementEmail: firstNonEmpty(src.copperContactEmail, src.contactEmail),
    dayOfContact: firstNonEmpty(src.eventContactName, src.dayOfContact),
    dayOfContactPhone: formatPhoneInput(firstNonEmpty(src.eventContactPhone, src.dayOfContactPhone)),
  };
}

export async function fetchAcceptanceContactPrefill({
  url, projectNumber, version, rwTicket, clientName, startDate, endDate, venueName,
}) {
  if (!url || !projectNumber) return null;
  const params = new URLSearchParams({
    projectNumber: String(projectNumber),
    version: String(version == null || version === '' ? '1' : version),
  });
  if (rwTicket) params.set('rwTicket', String(rwTicket));
  if (clientName) params.set('clientName', String(clientName));
  if (startDate) params.set('startDate', String(startDate));
  if (endDate) params.set('endDate', String(endDate));
  if (venueName) params.set('venueName', String(venueName));
  if (/script\.google\.com/i.test(url)) {
    params.set('action', 'getAcceptanceContactPrefill');
  }
  const joiner = url.includes('?') ? '&' : '?';
  try {
    const res = await fetch(`${url}${joiner}${params.toString()}`);
    const data = await res.json().catch(() => null);
    if (!data || data.success === false || !isAcceptanceContactPrefillPayload(data)) return null;
    return {
      copperContactName: firstNonEmpty(data.copperContactName, data.contactName),
      copperContactEmail: firstNonEmpty(data.copperContactEmail, data.contactEmail),
      contactName: firstNonEmpty(data.copperContactName, data.contactName),
      contactEmail: firstNonEmpty(data.copperContactEmail, data.contactEmail),
      eventContactName: firstNonEmpty(data.eventContactName, data.dayOfContact),
      eventContactPhone: firstNonEmpty(data.eventContactPhone, data.dayOfContactPhone),
    };
  } catch (_) {
    return null;
  }
}

export function prefillDayOfContactFields(proposal) {
  const rec = proposal || {};
  const name = firstNonEmpty(
    rec.eventContactName,
    rec.dayOfContact,
    rec.dayOfContactName
  );
  const phone = firstNonEmpty(
    rec.eventContactPhone,
    rec.dayOfContactPhone
  );
  return { dayOfContact: name, dayOfContactPhone: formatPhoneInput(phone) };
}

export const ACCEPTANCE_RESOURCE_MAX_BYTES = 8 * 1024 * 1024;
export const ACCEPTANCE_RESOURCE_EXTENSIONS = [
  '.pdf', '.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx',
  '.txt', '.csv', '.jpg', '.jpeg', '.png', '.gif', '.webp', '.heic',
];
export const ACCEPTANCE_RESOURCE_ACCEPT =
  ACCEPTANCE_RESOURCE_EXTENSIONS.join(',') + ',application/pdf,image/*';

export function isAllowedAcceptanceResource(file) {
  if (!file) return false;
  const name = String(file.name || '').trim().toLowerCase();
  const type = String(file.type || '').trim().toLowerCase();
  const size = Number(file.size) || 0;
  if (size > ACCEPTANCE_RESOURCE_MAX_BYTES) return false;
  const dot = name.lastIndexOf('.');
  const ext = dot >= 0 ? name.slice(dot) : '';
  if (ext && ACCEPTANCE_RESOURCE_EXTENSIONS.indexOf(ext) !== -1) return true;
  if (type === 'application/pdf' || type.indexOf('image/') === 0) return true;
  if (type.indexOf('officedocument') !== -1 || type.indexOf('msword') !== -1 || type.indexOf('ms-excel') !== -1 || type.indexOf('ms-powerpoint') !== -1) {
    return true;
  }
  return false;
}

export function acceptanceResourceRejection(file) {
  if (!file) return 'Choose a file to upload.';
  if ((Number(file.size) || 0) > ACCEPTANCE_RESOURCE_MAX_BYTES) {
    return 'Please choose a file smaller than 8 MB.';
  }
  if (!isAllowedAcceptanceResource({ name: file.name, type: file.type, size: 0 })) {
    return 'Please upload a PDF, image, or common document file.';
  }
  return '';
}

export function normalizeSupportingDocuments(list) {
  if (!Array.isArray(list)) return [];
  return list.map((item) => {
    const rec = asRecord(item);
    const id = String(rec.id || rec.fileId || '').trim();
    const name = String(rec.name || rec.fileName || '').trim();
    if (!id || !name) return null;
    return {
      id,
      name,
      url: String(rec.url || '').trim(),
      mimeType: String(rec.mimeType || '').trim(),
      uploadedAt: String(rec.uploadedAt || '').trim(),
      purpose: String(rec.purpose || '').trim() === 'coi' ? 'coi' : '',
    };
  }).filter(Boolean);
}

function acceptanceFolderLookupFields({
  rwTicket, clientName, startDate, endDate, venueName, clientFolderURL,
} = {}) {
  const out = {};
  if (rwTicket) out.rwTicket = String(rwTicket);
  if (clientName) out.clientName = String(clientName);
  if (startDate) out.startDate = String(startDate);
  if (endDate) out.endDate = String(endDate);
  if (venueName) out.venueName = String(venueName);
  if (clientFolderURL) out.clientFolderURL = String(clientFolderURL);
  return out;
}

export async function fetchProjectResources({
  url, projectNumber, version, clientFolderURL, rwTicket, clientName, startDate, endDate, venueName,
}) {
  if (!url || !projectNumber) return [];
  const params = new URLSearchParams({
    action: 'listProjectResources',
    projectNumber: String(projectNumber),
    version: String(version == null || version === '' ? '1' : version),
    ...acceptanceFolderLookupFields({ rwTicket, clientName, startDate, endDate, venueName, clientFolderURL }),
  });
  const joiner = url.includes('?') ? '&' : '?';
  try {
    const res = await fetch(`${url}${joiner}${params.toString()}`);
    const data = await res.json().catch(() => null);
    if (!data || data.success === false) return [];
    return normalizeSupportingDocuments(data.files).map((file) => ({ ...file, existing: true }));
  } catch (_) {
    return [];
  }
}

export async function uploadProjectResourceFile({
  url, projectNumber, version, clientFolderURL, rwTicket, clientName, startDate, endDate, venueName, file, base64,
}) {
  if (!url || !projectNumber || !file || !base64) {
    return { success: false, error: 'A file is required' };
  }
  const payload = {
    type: 'uploadProjectResource',
    projectNumber,
    version,
    fileName: file.name,
    mimeType: file.type || 'application/octet-stream',
    base64,
    ...acceptanceFolderLookupFields({ rwTicket, clientName, startDate, endDate, venueName, clientFolderURL }),
  };
  const isAppsScript = /script\.google\.com/i.test(url);
  const res = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': isAppsScript ? 'text/plain' : 'application/json' },
    body: JSON.stringify(payload),
  });
  const data = await res.json().catch(() => null);
  if (!data || data.success === false) {
    return { success: false, error: (data && data.error) || 'Could not upload that file.' };
  }
  return { success: true, file: normalizeSupportingDocuments([data.file])[0] || null };
}

export async function removeProjectResourceFile({
  url, projectNumber, version, clientFolderURL, rwTicket, clientName, startDate, endDate, venueName, fileId,
}) {
  if (!url || !projectNumber || !fileId) return { success: false, error: 'File is required' };
  const payload = {
    type: 'removeProjectResource',
    projectNumber,
    version,
    fileId,
    ...acceptanceFolderLookupFields({ rwTicket, clientName, startDate, endDate, venueName, clientFolderURL }),
  };
  const isAppsScript = /script\.google\.com/i.test(url);
  const res = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': isAppsScript ? 'text/plain' : 'application/json' },
    body: JSON.stringify(payload),
  });
  const data = await res.json().catch(() => null);
  if (!data || data.success === false) {
    return { success: false, error: (data && data.error) || 'Could not remove that file.' };
  }
  return { success: true };
}

export function unconfirmedIdsForEmptySnapshot(snapshot) {
  return PRODUCTION_FIELDS
    .filter((field) => !String(snapshot && snapshot[field.id] || '').trim())
    .map((field) => field.id);
}

export function validateAgreementStep(fields) {
  const errors = {};
  if (!String(fields && fields.agreementCompanyName || '').trim()) errors.agreementCompanyName = 'Enter the agreement / company name.';
  if (!String(fields && fields.agreementContactName || '').trim()) errors.agreementContactName = 'Enter the agreement contact name.';
  const email = String(fields && fields.agreementEmail || '').trim();
  if (!email) errors.agreementEmail = 'Enter the agreement email.';
  else if (!isValidEmail(email)) errors.agreementEmail = 'Enter a valid email address.';
  const payment = String(fields && fields.preferredPaymentMethod || '').trim();
  if (!payment) errors.preferredPaymentMethod = 'Select a preferred payment method.';
  else if (PAYMENT_METHOD_IDS.indexOf(payment) === -1) errors.preferredPaymentMethod = 'Select a valid payment method.';
  return errors;
}

export const FLOOR_PLAN_CONFIRMATION_ERROR = 'Select whether a floor plan is required.';

export function explicitFloorPlanAnswer(value) {
  const status = String(value == null ? '' : value).trim().toLowerCase();
  return status === 'required' || status === 'not_required' ? status : '';
}

/** Prefill only an already answered requirement. Unknown and anything else stay blank. */
export function confirmationFloorPlanAnswer(proposal) {
  const source = proposal && typeof proposal === 'object' ? proposal : {};
  const hasCamel = Object.prototype.hasOwnProperty.call(source, 'floorPlanStatus');
  const stored = hasCamel ? source.floorPlanStatus : source.floor_plan_status;
  return explicitFloorPlanAnswer(stored);
}

export function validateFloorPlanConfirmation(details) {
  if (explicitFloorPlanAnswer(details && details.floorPlanStatus)) return {};
  return { floorPlanStatus: FLOOR_PLAN_CONFIRMATION_ERROR };
}

export function buildAcceptanceRecord({
  proposal, fields, productionDetails, notYetConfirmed, submittedBy, source, originalProduction, originalAgreement, productionNotes, supportingDocuments, eventTimeZone,
}) {
  const version = normalizeVersion(proposal && proposal.version);
  const projectNumber = String((proposal && proposal.projectNumber) || '').trim();
  const unconfirmed = (Array.isArray(notYetConfirmed) ? notYetConfirmed : []).map((id) => String(id)).filter(Boolean);
  const inferred = applyInferredScheduleDates(productionDetails);
  const details = {};
  PRODUCTION_FIELDS.forEach((field) => {
    details[field.id] = unconfirmed.indexOf(field.id) !== -1
      ? NOT_YET_CONFIRMED
      : normalizeProductionValue(inferred && inferred[field.id]);
  });
  Object.assign(details, applyResolvedCoiDetails(details, proposal));
  const answeredFloorPlan = explicitFloorPlanAnswer(productionDetails && productionDetails.floorPlanStatus);
  if (answeredFloorPlan) details.floorPlanStatus = answeredFloorPlan;
  const snapshot = originalProduction || buildProductionSnapshot(proposal);
  const notes = String(productionNotes || '').trim();
  const zone = String(eventTimeZone || resolveVenueTimeZone({ proposal, venueAddress: details.venueAddress })).trim();
  const originalZone = String((proposal && (proposal.eventTimeZone || proposal.timezone)) || '').trim();
  const submittedAt = new Date().toISOString();
  const paymentTerms = resolveConfirmationPaymentTerms(proposal);
  const confirmationSnapshot = buildConfirmationSnapshot({
    proposal,
    fields,
    productionDetails: details,
    originalProduction: snapshot,
    originalAgreement: originalAgreement || prefillAgreementFields(proposal),
    productionNotes: notes,
    supportingDocuments,
    eventTimeZone: zone,
    submittedAt,
  });
  return {
    acceptedAt: submittedAt,
    confirmationSubmittedAt: submittedAt,
    acceptedProposalVersion: version,
    acceptedProposalProjectNumber: projectNumber,
    submittedBy: {
      name: String((submittedBy && submittedBy.name) || fields.agreementContactName || '').trim(),
      email: normalizeEmail((submittedBy && submittedBy.email) || fields.agreementEmail),
    },
    agreementCompanyName: String(fields.agreementCompanyName || '').trim(),
    agreementContactName: String(fields.agreementContactName || '').trim(),
    agreementEmail: normalizeEmail(fields.agreementEmail),
    preferredPaymentMethod: String(fields.preferredPaymentMethod || '').trim(),
    paymentTerms: paymentTerms.id,
    paymentTermsLabel: paymentTerms.label,
    floorPlanStatus: answeredFloorPlan,
    productionDetails: details,
    productionChanges: collectProductionChanges(applyInferredScheduleDates(snapshot), details, unconfirmed, {
      productionNotes: notes,
      eventTimeZone: zone,
      originalTimeZone: originalZone,
    }),
    confirmationSnapshot,
    hasScopeSensitiveChanges: Boolean(confirmationSnapshot.hasScopeSensitiveChanges),
    notYetConfirmed: unconfirmed,
    productionNotes: notes,
    supportingDocuments: normalizeSupportingDocuments(supportingDocuments),
    eventTimeZone: zone,
    agreementStatus: 'pending',
    agreementError: '',
    source: source || 'reserve',
    clickUpTaskId: '',
    clickUpTaskUrl: '',
  };
}

export function nextProjectStatusAfterAcceptance(currentStatus) {
  const status = String(currentStatus || '').trim();
  if (TERMINAL_PROJECT_STATUSES.has(status)) return status;
  return 'Approved';
}

// Copy-only: which confirmation payment line to show the client.
// Does not select or persist payment terms, and does not set Confirmed.
export function daysUntilYmd(ymd, asOf) {
  const parsed = parseYmd(ymd);
  if (!parsed) return null;
  const [year, month, day] = parsed.split('-').map((n) => parseInt(n, 10));
  const event = new Date(year, month - 1, day);
  const basis = asOf instanceof Date && !isNaN(asOf.getTime()) ? asOf : new Date();
  const today = new Date(basis.getFullYear(), basis.getMonth(), basis.getDate());
  return Math.round((event.getTime() - today.getTime()) / 86400000);
}

export function agreementRequiresFullPayment(proposal, asOf) {
  const days = daysUntilYmd(proposal && proposal.startDate, asOf);
  if (days == null) return false;
  return days <= 45;
}

export function agreementConfirmationCopy(proposal, asOf) {
  const terms = resolveConfirmationPaymentTerms(proposal);
  if (terms.kind === 'net') return netConfirmationCopy(terms.days);
  if (terms.kind === 'full_upfront') return STANDARD_FULL_PAYMENT_CONFIRMATION_COPY;
  if (terms.kind === 'standard') return STANDARD_DEPOSIT_CONFIRMATION_COPY;
  return UNSPECIFIED_PAYMENT_CONFIRMATION_COPY;
}

/**
 * "Confirmation and Payment" text on the proposal view and PDF.
 * Follows the proposal's term instead of always saying deposit.
 */
export function confirmationAndPaymentSentence(proposal) {
  const terms = resolveConfirmationPaymentTerms(proposal);
  let lead;
  if (terms.kind === 'standard') lead = 'Projects are confirmed with a signed service agreement and 50% deposit.';
  else if (terms.kind === 'full_upfront') lead = 'Projects are confirmed with a signed service agreement and full payment.';
  else if (terms.kind === 'net') lead = `Projects are confirmed with a signed service agreement. Payment is due Net ${terms.days}.`;
  else if (terms.kind === 'custom' && String(terms.label || '').trim()) {
    lead = `Projects are confirmed with a signed service agreement. Payment is due ${String(terms.label).trim()}.`;
  } else lead = 'Projects are confirmed with a signed service agreement and payment per your proposal terms.';
  return `${lead} We accept wire, ACH, credit card (3% processing fee), and check.`;
}

export function formatEventDateRange(proposal) {
  return formatDisplayDateRange(parseYmd(proposal && proposal.startDate), parseYmd(proposal && proposal.endDate));
}

export function countUpdatedProductionDetails(acceptance) {
  return ((acceptance && acceptance.productionChanges) || []).length;
}

export async function submitProposalAcceptance(payload, { adminApiUrl } = {}) {
  const slimPayload = {
    ...payload,
    proposalSnapshot: slimProposalSnapshot(payload.proposalSnapshot),
  };
  if (!adminApiUrl) {
    return { success: false, error: 'Unable to submit your acceptance.' };
  }
  try {
    const { response, result } = await fetchJsonWithTimeout(adminApiUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(slimPayload),
    });
    const accepted = Boolean(response && response.ok && result && result.success === true);
    if (!accepted) {
      return {
        ...(result && typeof result === 'object' ? result : {}),
        success: false,
        error: (result && result.error) || 'Unable to submit your acceptance.',
      };
    }
    const approvalKind = result.approvalKind || (result.acceptance && result.acceptance.lastApprovalKind) || '';
    kickConfirmationHandoff({
      adminApiUrl,
      projectNumber: slimPayload.projectNumber,
      version: slimPayload.version,
      skipDocumentGeneration: approvalKind === 'reapproval',
    });
    return result;
  } catch (err) {
    return {
      success: false,
      error: (err && err.message) || 'Unable to submit your acceptance.',
    };
  }
}
